import axios from 'axios'

const RESSOURCE_NAME = 'communes'

export default {
    getCommunes(id_marche) {
        return axios.get(`${RESSOURCE_NAME}/${id_marche}`)
    }
}